import { useLayoutEffect, useRef } from 'react';

/**
 * Resets window and container scroll when dependency changes (e.g. route/product id).
 */
export function useScrollToTop(dependency) {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [dependency]);

    return containerRef;
}
